const coolNames = [
    "Mammoth 2",
    "Blinker",
    "FearLeSS",
    "Slug-em-dog",
    "RawSkills",
    "Danqqqqq",
    "3P-own",
    "VileHero",
    "Predator",
    "Freaky Ratbuster",
    "NeoGermal",
    "FireBrang",
    "Fatsy Bear",
    "HolyCombo",
    "ThickSKN",
    "Dark Matter",
    "BuffFreak",
    "HOV",
    "2nd Hand Joe",
    "ThermalMode",
    "Flotsams54",
    "Redneck Giorgio",
    "CodeExia",
    "Roadspike",
    "Mechani-Man",
    "Kazami of Truth",
    "Gbbledgoodk",
    "High Beam",
    "Eye Devil",
    "Swing Setter",
    "Tea Kettle",
    "MrOnsTr",
    "Wrangler Jim",
    "Flint Cast-Iron",
    "Kinged",
    "Lucifurious",
    "Lewd Dice",
    "RZR",
    "LerveDr",
    "Flyswat Briggs",
    "Legacy",
    "Shade Nightman",
    "PP Dubs",
    "Prone",
    "Hemingway Mirmillone",
    "Scooby Did",
    "Stealth",
    "Slinger",
    "Preach Man",
    "Unseen",
    "Crossing Guard",
    "Bad Bond",
    "Force",
    "FRMhndshk",
    "Easy Mac",
    "Sky",
    "SkyGod",
    "Toxic-oxide",
    "Silent",
    "GiddeeUP",
    "Irish Dze",
    "Apex",
    "DragonBlood",
    "Tse Tse Guy",
    "Shay",
    "IceDog",
    "Dallas Foxface",
    "Sloth",
    "Lounge Master",
    "Sprinkle Lovenuts",
    "Sokol",
    "DeathDancer",
    "Zorkle Sporkle",
    "Skool",
    "Pompeii Unicorn",
    "Noise Toy",
    "Flash",
    "Achilles Mountain",
    "Whip Chu",
    "Elektrik",
    "Bad Badminton",
    "Sly Silvermoon",
    "LocKz",
    "THRESHmSTR",
    "Tin Mutt",
    "ReiGnZ",
    "High-Fructose",
    "Sweet Bacon",
    "Coldy",
    "Sepukku",
    "Crazy Rox",
    "Beo",
    "Valley Guardian",
    "1st Degree",
    "Ice",
    "Sw00sh",
    "Bom Crossed",
    "Unleashed",
    "Ba1t",
    "Sick Saurus",
    "Corny",
    "SneakerKid",
    "Mad Viral",
    "Steel",
    "ShadowFax",
    "Clang Glyph",
    "Ex0tic",
    "Hermopolis",
    "xFRST",
    "VPR",
    "ManManMan",
    "Mosquit-No",
    "LyRz",
    "Firedog",
    "ELLerG!c",
    "Lime",
    "German Coach",
    "Hex Panther",
    "Energy",
    "Y0dler",
    "xSTORMx",
    "Blade",
    "WeldMaster",
    "Die Slice",
    "Tunez",
    "Steel Cut Toe",
    "Free Ham",
    "Truth",
    "Forger",
    "Dr. Jam Man",
    "Lskeee",
    "Black Walnut",
    "Seattle Jay",
    "Pexxious",
    "Journeyman",
    "RDTN",
    "Venious",
    "Plegasus",
    "Whip 2T",
    "Grotas",
    "Carrot Joker",
    "Skirble",
    "Sherm",
    "Switch",
    "Solitaire",
    "Gro",
    "Hobo Samurai",
    "Prof. Smirk",
    "Indestructible Potato",
    "Good William",
    "GuTzd",
    "Kamikaze Grandma",
    "Infinite Hole",
    "Are Ess Tee",
    "Badger the Burglar",
    "Sw33per",
    "Sir Squire",
    "Mauve Cactus",
    "Hidden Tree",
    "Deano",
    "Bruh",
    "AxelRoad",
    "Uncle Buddy",
    "Fadey",
    "Goldman",
    "Copilot",
    "Z-Boy",
    "Fl00d",
    "Bones",
    "DZE",
    "Danger Menace",
    "Vermilion",
    "Muzish",
    "Hang 11",
    "TrinitySoul",
    "Cooger",
    "Delicious Wing",
    "BlackExcalibur",
    "Kazmii",
    "Doz",
    "Risen",
    "AirportHobo XD",
    "Prez Dog",
    "ShadowDancer",
    "Cumulo",
    "Baked ZD",
]

const animeNames = [
    "Yoko",
    "Etsuko",
    "Kanna",
    "Honoka",
    "Katsumi",
    "Hiroaki",
    "Miwa",
    "Satashi",
    "Kohaku",
    "Ami",
    "Ran",
    "Chika",
    "Noa",
    "Mana",
    "Ryuunosuke",
    "Hinata",
    "Bashira",
    "Masahiro",
    "Druvish",
    "Keiko",
    "Aiko",
    "Norio",
    "Manami",
    "Mika",
    "Yua",
    "Hiroko",
    "Noburu",
    "Melaina",
    "Minako",
    "Kichiro",
    "Aini",
    "Masanori",
    "Hisashi",
    "Mi",
    "Akihiro",
    "Chieko",
    "Kyoko",
    "Tadashi",
    "Fumio",
    "Shinobu",
    "Wakana",
    "Katsuo",
    "Sora",
    "Tanaka",
    "Natsumi",
    "Takara",
    "Hideaki",
    "Chikako",
    "Kazuhiko",
    "Atsuko",
    "Kanako",
    "Momoka",
    "Satoko",
    "Asuka",
    "Kasai",
    "Saburo",
    "Kanon",
    "Tomiko",
    "Masuyo",
    "Toshiro",
    "Tadao",
    "Chiyoko",
    "Ryo",
    "Aimi",
    "Amaya",
    "Kenta",
    "Yumi",
    "Masami",
    "Madoka",
    "Yui",
    "Chiharu",
    "Jun",
    "Miku",
    "Nanami",
    "Airi",
    "Mei",
    "Hideki",
    "Devroop",
    "Haruko",
    "Masaki",
    "Aina",
    "Akio",
    "Nana",
    "Masao",
    "JunichiJunko",
    "Michio",
    "ttack on Titan",
    "Bamboo Blade",
    "Black Clover",
    "Bleach",
    "Bokurano",
    "Case Closed",
    "Code Geas",
    "Dagashi Kashi",
    "Dragon Ball Z",
    "Dragonball",
    "Dragonball Z",
    "Fairy Tail",
    "Fate Zero",
    "Fruits Basket",
    "Fullmetal Alchemist",
    "Gargantia on the Verdurous Planet",
    "Ghost in the Shell",
    "Gintama",
    "Hunter × Hunter",
    "Hunter x Hunter",
    "Kekkaishi",
    "Lucky Star",
    "Most Popular",
    "My Hero Academia",
    "Naruto",
    "Neon Genesis Evangelion",
    "One Piece",
    "OnePiece",
    "OnePunch Man",
    "Pokemon",
    "Sailor Moon",
    "Samurai Champloo",
    "Sounja",
    "Space Dandy",
    "Sword Art Online",
    "Tiger & Bunny",
    "Yugioh!",
    "Sukuwa Isayumi",
    "Sekigishi Hoshizuka",
    "Yamakuda Airi",
    "Aritani Asakari",
    "Mizumiya Wadiri",
    "Kamimuro Chitomi",
    "Inatsuka Tadakuri",
    "Mananashi Tokinatsu",
    "Nagiri Sase",
    "Sesugi Mikayoko",
    "Motoruno Natsumaki",
    "Sakimaru Gisuki",
    "Nitsami Kinutsumi",
    "Sumiri Makifumi",
    "Migiri Sakuyoshi",
    "Ashishida Kamimaki",
    "Isejima Ichikemi",
    "Shino Yasunuye",
    "Mitsugisawa Hirosagi",
    "Nakanashi Yasami",
    "Edabe Fumirata",
    "Marusawa Manasine",
    "Miyomi Gekasu",
    "Hisasano Chikao",
    "Hirato Koshi",
    "Minanari Okitane",
    "Yashigata Hyomao",
    "Izuzuno Ichisai",
    "Mizukama Munibu",
    "Sekisugi Mareyasu",
    "Takemisu Mitsuseki",
    "Kurigawa Samara",
    "Kinashi Tadishige",
    "Shinotsuka Mitsunso",
    "Kinokuda Moshin",
    "Edano Shinikoto",
    "Kinaha Atatoru",
    "Amenobu Atakeno",
    "Ishiro Tomosuke",
    "Suzato Kutoshi",
    "Kagaken Ashichu",
    "Shirase Yomuro",
    "Fugome Bomara",
    "Hamabi Yanpaku",
    "Shinoyoshi Haragawa",
    "Azuma Shinikko",
    "Yashitani Tsunenao",
    "Izutase Kanzakichi",
    "Hisawata Kyosashi",
    "Tasari Shotoshi",
    "Katsukino Okamichi",
    "Yoshimuro Mitsushi",
    "Kokura Tamunokoji",
    "Nishiziwa Tsubumi",
    "Wakukuma Jinzachiro",
    "Nosho Tonsei",
    "Hatamura Yorihei",
    "Agazaki Akiyuki",
    "Kakura Yorikumi",
    "Mamoto Tsumochi",
    "Akira",
    "Battle Angel Alita",
    "Bleach",
    "Dragon Ball",
    "Eyeshield 21",
    "Ghost in the Shell",
    "Honeysuckle",
    "Mononoke",
    "Naruto",
    "Sailor Moon",
    "Tenchi Muyo",
    "Beautiful Child",
    "Cherry Blossoms",
    "Quiet Child",
    "Spiritual Meanings",
    "Beauty",
    "Morning Beauty",
    "Blossom",
    "Wise Child",
    "Child Of Dance",
    "Happy Child",
    "Japanese Origin",
    "Villain",
    "True Beauty",
    "Dance Cherry Blossom",
    "Fairy Tail",
    "Anime Boy Names",
    "Blessed Child",
    "Bright Child",
    "Butterfly Child",
    "Metal Alchemist",
    "Black Butler",
    "Straw Hat",
    "Levi Ackerman",
    "Archery Bow",
    "Alchemist",
    "Uta",
    "Nishida",
    "Brown",
    "Saber",
    "The Apocalypse Burger",
    "Baldric",
    "Angel",
    "Phil",
    "Blue",
    "The Idiot Factory",
    "Zerlina",
    "Sound",
    "Hanyū",
    "Saber’s Smoke House",
    "Touka",
    "The Fallen Angel",
    "Green",
    "Myers",
    "Windy",
    "Water",
    "Kaneki",
    "Brooks",
    "The Waiting Room",
    "The Bureau of Physics",
    "Ren",
    "Lucy",
    "Sienna",
    "Plump",
    "Baruto",
    "Kan",
    "Crimson",
    "Tanuki",
    "Atsushi",
    "Yui",
    "Ethan",
    "The Forbidden Box",
    "The Legendary Hero",
    "Hajime",
    "Shiro",
    "Aku no Hana",
    "Taizo",
    "Candy",
    "Axel",
    "Soga",
    "Ancient",
    "Oscar",
    "Fiery",
    "Suitcase",
    "Mystic Wanderer",
    "Nana",
    "Merlin",
    "Jack",
    "Kenji",
    "Touka",
    "The Gospel of Steve Jobs",
    "Alex",
    "Hardcastle",
    "Barbie Dream House",
    "Isamu",
    "Shun",
    "Hirono",
    "Name Unknown",
    "Saint Purple Demon",
    "Light",
    "Thea",
    "Holly",
    "Salmon",
    "Nakamura",
    "Sushi",
    "The Ultimate Evil",
    "The Delinquent’s Evil",
    "Pokeman",
    "Taichi",
    "Pumpkin",
    "Dusk",
    "Louis Vuitton",
    "Riley",
    "Oda",
    "The Terminator",
    "Dark",
    "Juvia",
    "Ayase",
    "The Silver Crane",
    "The Philosopher’s Party",
    "Connor",
    "Yamuz",
    "Kanda",
    "Jenny’s Milkshakes",
    "Flash",
    "Rafael",
    "Kogoro",
    "Takashi",
    "Yotsuba",
    "Red",
    "Sunshine",
    "Setsuna",
    "Gale",
    "Sawako",
    "Shizuha",
    "Kaname",
    "Kaneki",
    "Yokai",
]

const elfFemale = [
    "Aalya",
    "Aerin",
    "Allyrion",
    "Ammae",
    "Apperford",
    "Arinalue",
    "Arrely",
    "Arwynn",
    "Ashford",
    "Aurola",
    "Avilyn",
    "Avitihne",
    "Bancey",
    "Bayle",
    "Beatsarda",
    "Beesbury",
    "Beicaryn",
    "Camyla",
    "Crane",
    "Daedi",
    "Donnis",
    "Durwell",
    "Eilgolor",
    "Elbereth",
    "Elrora",
    "Elyana",
    "Esalin",
    "Estel",
    "Esthis",
    "Eyva",
    "Faenys",
    "Gaenzira",
    "Garner",
    "Gifmedha",
    "Gislila",
    "Glynrie",
    "Gresnalyn",
    "Haleth",
    "Halyziar",
    "Helehorn",
    "Herdan",
    "Jaidyn",
    "Jelissa",
    "Joansevel",
    "Johvis",
    "Keyvyre",
    "Kririah",
    "Laerra",
    "Leodove",
    "Lia",
    "Liamyar",
    "Liayra",
    "Maryana",
    "Melian",
    "Meya",
    "Mirazumin",
    "Morwen",
    "Norrey",
    "Norydark",
    "Ololar",
    "Oloxina",
    "Pabanise",
    "Parge",
    "Reyanna",
    "Reyanna",
    "Rina",
    "Sesa",
    "Shaed",
    "Siofra",
    "Sylvina",
    "Tallhart",
    "Taner",
    "Teflorna",
    "Teftrana",
    "Umezorwyn",
    "Valxina",
    "Vicraera",
    "Virdan",
    "Waker",
    "Wynna",
    "Yinlee",
    "Yvkiasha"

]

const elfMale = [
    "Aelfdene",
    "Aelfric",
    "Ailwyn",
    "Aktaion",
    "Alberic",
    "Aldon",
    "Alstin",
    "Balin",
    "Biwenys",
    "Brackwell",
    "Bryer",
    "Bulwer",
    "Byrant",
    "Callon",
    "Cartwell",
    "Charcraes",
    "Cherman",
    "Crowlin",
    "Daewynn",
    "Daman",
    "Dondarrion",
    "Emellan",
    "Elrand",
    "Gabthor",
    "Gordar",
    "Haldir",
    "Hamell",
    "Heleqirelle",
    "Hentevar",
    "Isemthil",
    "Ishton",
    "Jarvoril",
    "Jimmer",
    "Khort",
    "Krismys",
    "Kyllan",
    "Lindir",
    "Olaqen",
    "Peregrin",
    "Presphine",
    "Pyne",
    "Richenas",
    "Richtevar",
    "Ridman",
    "Roberd",
    "Rohan",
    "Rud",
    "Seamas",
    "Syltumil",
    "Teague",
    "Terlaern",
    "Theoden",
    "Torgeiros",
    "Ulajyre",
    "Yelkrana",
]

const fantasyNames = [
    "Akibrus",
    "Aleera",
    "Alva",
    "Angun",
    "Balrus",
    "Breya",
    "Bulruk",
    "Caldor",
    "Ciscra",
    "Dagen",
    "Darvyn",
    "Delvin",
    "Dracyian",
    "Drusila",
    "Lunarex",
    "Mireille",
    "Nyssa",
    "Olwyn",
    "Peregrine",
    "Remus",
    "Rorik",
    "Shikta",
    "Soril",
    "Turilla",
    "Zarek",
]

const futuristicNames = [
    "Abriana",
    "Abrielle",
    "Acacia",
    "Ace",
    "Adelie",
    "Aeliana",
    "Aella",
    "Aemilia",
    "Agnia",
    "Ailana",
    "Aisling",
    "Aislinn",
    "Aiyana",
    "Akilah",
    "Alanis",
    "Alchemy",
    "Alcina",
    "Alcyone",
    "Alder",
    "Alena",
    "Alessa",
    "Alessia",
    "Alethea",
    "Alexa",
    "Alexis",
    "Alia",
    "Aliana",
    "Alida",
    "Aliena",
    "Alienor",
    "Aline",
    "Aliza",
    "Allura",
    "Alouette",
    "Amaia",
    "Amalia",
    "Amara",
    "Amaranth",
    "Amaris",
    "Amena",
    "Amerie",
    "Amethyst",
    "Amia",
    "Amory",
    "Anais",
    "Anastasia",
    "Andromeda",
    "Anemone",
    "Angeliki",
    "Anise",
    "Annora",
    "Antheia",
    "Antinea",
    "Aquilina",
    "Aquilo",
    "Arcadia",
    "Arden",
    "Ardith",
    "Arella",
    "Aria",
    "Ariadne",
    "Ariane",
    "Ariel",
    "Arlo",
    "Artemis",
    "Artemisia",
    "Ascella",
    "Ash",
    "Aspen",
    "Astera",
    "Asteria",
    "Astoria",
    "Astra",
    "Astraea",
    "Astrid",
    "Astrophel",
    "Asya",
    "Atalanta",
    "Athalia",
    "Auden",
    "Aura",
    "Aure",
    "Aurelia",
    "Aureliana",
    "Aurelina",
    "Aurelle",
    "Auretta",
    "Auria",
    "Auriel",
    "Auriella",
    "Aurielle",
    "Aurilla",
    "Aurora",
    "Avalon",
    "Avianna",
    "Avita",
    "Aviva",
    "Avril",
    "Azalea",
    "Azaria",
    "Azenor",
    "Aziza",
    "Azura",
    "Azure",
    "Aeliora",
    "Alzora",
    "Ankh",
    "Asphodel",
    "Astaria",
    "Astarla",
    "Astaroth",
    "Aster",
    "Balthazar",
    "Betony",
    "Bianca",
    "Bijou",
    "Blaise",
    "Bliss",
    "Blossom",
    "Blythe",
    "Briallen",
    "Briar",
    "Brielle",
    "Bryony",
    "Cadence",
    "Cadenza",
    "Caia",
    "Caio",
    "Caius",
    "Calandra",
    "Calantha",
    "Calanthe",
    "Caledonia",
    "Calico",
    "Calida",
    "Calixta",
    "Calla",
    "Calliope",
    "Callisto",
    "Calypso",
    "Cambria",
    "Camellia",
    "Canary",
    "Carina",
    "Carissa",
    "Carnation",
    "Cassia",
    "Cassian",
    "Cassiopeia",
    "Cassius",
    "Catalina",
    "Catriona",
    "Cedar",
    "Celeste",
    "Celestia",
    "Cerelia",
    "Cerella",
    "Ceres",
    "Cerise",
    "Cerissa",
    "Chara",
    "Charis",
    "Charisma",
    "Charmian",
    "Chiara",
    "Christia",
    "Chrysanthemum",
    "Citrine",
    "Clarion",
    "Clelia",
    "Cleona",
    "Cleora",
    "Cliantha",
    "Clio",
    "Cloud",
    "Cordelia",
    "Corinna",
    "Corona",
    "Corvina",
    "Cosima",
    "Cove",
    "Crescentia",
    "Cressida",
    "Cymbre",
    "Cyra",
    "Cyrilla",
    "Celosia",
    "Charm",
    "Coriander",
    "Crescent",
    "Dalla",
    "Damara",
    "Damaris",
    "Danae",
    "Dara",
    "Daria",
    "Darius",
    "Demeter",
    "Demetria",
    "Diamond",
    "Diandra",
    "Dianthe",
    "Diarra",
    "Dido",
    "Dion",
    "Dione",
    "Dionne",
    "Doria",
    "Dove",
    "Dream",
    "Ebony",
    "Echo",
    "Eden",
    "Elara",
    "Eleni",
    "Elettra",
    "Eliana",
    "Elida",
    "Elika",
    "Elina",
    "Eliora",
    "Elizabella",
    "Elka",
    "Elke",
    "Ellery",
    "Ellia",
    "Elora",
    "Elyse",
    "Elysia",
    "Ember",
    "Emerald",
    "Emilia",
    "Emiliana",
    "Emory",
    "Endellion",
    "Ennis",
    "Enya",
    "Eos",
    "Ereni",
    "Eris",
    "Estella",
    "Estrella",
    "Eulalia",
    "Eulalie",
    "Evadne",
    "Evanna",
    "Evanthe",
    "Ever",
    "Everly",
    "Evony",
    "Ellony",
    "Fable",
    "Fallon",
    "Farrah",
    "Fawn",
    "Felicity",
    "Fennel",
    "Fionn",
    "Flavia",
    "Freya",
    "Gaia",
    "Galatea",
    "Garnet",
    "Gemini",
    "Genesis",
    "Giada",
    "Gianna",
    "Geranium",
    "Haven",
    "Helia",
    "Hera",
    "Hermione",
    "Hero",
    "Hestia",
    "Ianthe",
    "Ilaria",
    "Indigo",
    "Ione",
    "Isis",
    "Ivara",
    "Ivory",
    "Jacinta",
    "Jade",
    "Jasper",
    "Jett",
    "Jocasta",
    "Jonquil",
    "Junia",
    "Juniper",
    "Junius",
    "Joliette",
    "Kale",
    "Kara",
    "Karis",
    "Kestrel",
    "Kore",
    "Lapis",
    "Laurel",
    "Lavender",
    "Layla",
    "Lazuli",
    "Leia",
    "Leonidas",
    "Lianne",
    "Lilac",
    "Lilika",
    "Lilium",
    "Lilou",
    "Linden",
    "Linnea",
    "Lior",
    "Lore",
    "Lucius",
    "Lumina",
    "Lux",
    "Lylah",
    "Lyra",
    "Lyric",
    "Lys",
    "Lysa",
    "Lysander",
    "Lysandra",
    "Lystra",
    "Lunara",
    "Luxora",
    "Marni",
    "Mazarine",
    "Meghan",
    "Meryl",
    "Minerva",
    "Minna",
    "Moon",
    "Morena",
    "Mycah",
    "Mint",
    "Myrrh",
    "Narcissa",
    "Natania",
    "Neriah",
    "Nerissa",
    "Nia",
    "Niall",
    "Nova",
    "Nyx",
    "Nox",
    "Obelia",
    "Octavia",
    "Odelia",
    "Odessa",
    "Ofelia",
    "Oleander",
    "Oneida",
    "Onyx",
    "Opal",
    "Oralis",
    "Orchid",
    "Orella",
    "Oriana",
    "Oriane",
    "Oriel",
    "Orlaith",
    "Pallas",
    "Pepper",
    "Persephone",
    "Petra",
    "Phaedra",
    "Phelia",
    "Phoebe",
    "Placida",
    "Placidia",
    "Priscilla",
    "Parsley",
    "Raine",
    "Ramona",
    "Raven",
    "Reign",
    "Rena",
    "Revel",
    "Reverie",
    "Rhea",
    "Rhian",
    "Rhona",
    "Rin",
    "Roanna",
    "Robin",
    "Rosella",
    "Roux",
    "Roxana",
    "Roza",
    "Rune",
    "Rhine",
    "Sabina",
    "Sable",
    "Saffron",
    "Saga",
    "Sage",
    "Sapphira",
    "Sapphire",
    "Saskia",
    "Scarlett",
    "Selah",
    "Selena",
    "Selene",
    "Senara",
    "Senna",
    "Sephora",
    "Serafim",
    "Serafin",
    "Serafina",
    "Seraphim",
    "Seraphina",
    "Sereia",
    "Seren",
    "Serena",
    "Severine",
    "Sheena",
    "Shiloh",
    "Silvia",
    "Sirena",
    "Skylar",
    "Sloane",
    "Snow",
    "Sofie",
    "Sol",
    "Solana",
    "Soleil",
    "Solene",
    "Sonata",
    "Sonnet",
    "Sonora",
    "Sora",
    "Sorcha",
    "Sorrel",
    "Star",
    "Starla",
    "Stasia",
    "Stella",
    "Sybella",
    "Sylvie",
    "Sylvine",
    "Solandra",
    "Talia",
    "Taliesin",
    "Tamara",
    "Tamora",
    "Tamsin",
    "Tamsyn",
    "Tanis",
    "Taryn",
    "Tassia",
    "Tatum",
    "Tavia",
    "Tawny",
    "Terra",
    "Tertia",
    "Tessa",
    "Thalassa",
    "Thalia",
    "Thea",
    "Theia",
    "Theone",
    "Theta",
    "Thisbe",
    "Thyme",
    "Thyra",
    "Tiana",
    "Timber",
    "Topaz",
    "Trinity",
    "Tullia",
    "Turia",
    "Tyr",
    "Tyra",
    "Unity",
    "Urania",
    "Vada",
    "Valeria",
    "Valora",
    "Vanina",
    "Varina",
    "Varinia",
    "Veda",
    "Vega",
    "Vela",
    "Velia",
    "Venus",
    "Verbena",
    "Verena",
    "Verina",
    "Verity",
    "Vita",
    "Vivia",
    "Willow",
    "Wisteria",
    "Wren",
    "Xanthe",
    "Xanthia",
    "Xena",
    "Xene",
    "Xenia",
    "Yalena",
    "Yana",
    "Yarrow",
    "Zabel",
    "Zafira",
    "Zaina",
    "Zaira",
    "Zamora",
    "Zaria",
    "Zarina",
    "Zelda",
    "Zelia",
    "Zelina",
    "Zella",
    "Zen",
    "Zenaida",
    "Zenobia",
    "Zeta",
    "Zillah",
    "Zinnia",
    "Zora",
    "Zosia",
]

const medievalNames = [
    "Phrowenia",
    "Zemislav",
    "Amicia",
    "Wymar",
    "Odilia",
    "Wolfgang",
    "Sabelina",
    "Warin",
    "Reina",
    "Theobald",
    "Krea",
    "Teague",
    "Sybil",
    "Tancred",
    "Rohesia",
    "Rolund",
    "Aleida",
    "Rogue",
    "Oriel",
    "Reynard",
    "Ryia",
    "Radax",
    "Heloise",
    "Percival",
    "Damiana",
    "Odo",
    "Isolde",
    "Maurin",
    "Trea",
    "Lucan",
    "Linota",
    "Lief",
    "Sigourney",
    "Justus",
    "Clement",
    "Joachim",
    "Ida",
    "Ives",
    "Herleva",
    "Ingram",
    "Celestina",
    "Gawain",
    "Elysande",
    "Galien",
    "Thora",
    "Gaillard",
    "Rhoslyn",
    "Finnian",
    "Gwenllian",
    "Ferand",
    "Sigrid",
    "Faramond",
    "Lavinia",
    "Evrouin",
    "Aquila",
    "Everard",
    "Katelyn",
    "Drogo",
    "Ismay",
    "Doran",
    "Alianor",
    "Bertram",
    "Theophania",
    "Berinon",
    "Geva",
    "Aymon",
    "Ayleth",
    "Ansel",
    "Estrilda",
    "Althalos",
    "Emeline",
    "Alphonse",
    "Alba",
    "Aldous",
    "Maerwynn",
    "Adelard",
    "Elspeth",
    "Tybalt",
    "Duraina",
    "Sadon",
    "Malkyn",
    "Borin",
    "Helewis",
    "Carac",
    "Anastas",
    "Asher",
    "Petronilla",
    "Gorvenal",
    "Ellyn",
    "Ranulf",
    "Richolda",
    "Umfrey",
    "Godiva",
    "Ymbert",
    "Enndolynn",
    "Helyas",
    "Gussalen",
    "Amalric"
]

const hackerNames = [
    "6R1M",
    "570RM",
    "P4R460N",
    "6R4C3",
    "45P3C7",
    "LYNX",
    "570RM",
    "Z16Z46",
    "5QU1R7",
    "M3RM41D",
    "D0PP3L64N63R",
    "P4R0DY",
    "K155",
    "CHR0N1CL3",
    "BURN",
    "1D0L",
    "6H0UL",
    "PR0XY",
    "B173",
    "5QU1R7",
    "7R3M0R",
    "LYNX",
    "PL46U3",
    "5PH1NX",
    "4N7",
    "BL155",
    "3P170M3",
    "B15H0P",
    "0WL",
    "N3M3515",
    "M3M0RY",
    "RUN3",
    "5H4D3",
    "5P00K",
    "6R1M",
    "M3RM41D",
    "W3B",
    "L16H7N1N6",
    "4LPH4",
    "DUCKL1N6",
    "5URPR153",
    "N0B0DY",
    "5463",
    "4B53NC3",
    "4QU4",
    "6R1FF1N",
    "WYV3RN",
    "FL45H",
    "V31L",
    "0R4CL3",
    "5QU1R7",
    "V3RM1N",
    "PH0B14",
    "L4W",
    "C0MPL3X",
    "470M",
    "CRYP70",
    "N3M3515",
    "57R34K",
    "W3B",
    "5UN5H1N3",
    "7R4C3",
    "1MP0551BL3",
    "B173",
    "CR4Z3",
    "5QU1R7",
    "CH405",
    "7R4C3R",
    "N16H7H4WK",
    "CH13F",
    "R4Y",
    "H4B1747",
    "6LU770NY",
    "L364CY",
    "R4Y",
    "V3RM1N",
    "M07H3R5H1P",
    "N3M0",
    "1D0L",
    "4L4K4Z4M",
    "PH4N70M",
    "L16H7N1N6",
    "W3B573R",
    "M00NL16H7",
    "5H3PH3RD",
    "3553NC3",
    "7R1XY",
    "CH4RM",
    "4RCH4N63L",
    "4N7",
    "54B3R7007H",
    "C0MPL3X",
    "3553NC3",
    "5P3C73R",
    "QU4D",
    "P4N7H3R",
    "LYNX",
    "KN16H7",
    "5L07H",
    "B15H0P"
]

const unicodeNames = [
    "(❁´◡`❁)",
    "꧁༒☬ᤂℌ໔ℜ؏ৡ☬༒꧂",
    "꧁༒☬IRISVIEL☬༒꧂",
    "₣₁₁⁷⁰⁶᾿‖ᵒᵡ‖",
    "SilverGon",
    "༄ᶦᶰᵈ᭄✿ɓίɡ•ʍεʆʆσϖϖ࿐",
    "﷽",
    "L A H K O K M A T I",
    "『𝙍𝘼𝙎』𝔼-𝕊ℙ𝕆𝕋ℝメ",
    "🅿🅰🅿",
    "꧁☬TђєA∩₫єяSø∩☬꧂",
    "💭.♡`Ριყყσ 。🐇🎀",
    "₣₁₁☢イԾxiĉԾ",
    "﷽﷽﷽﷽",
    "𝕦𝕘𝕝𝕪𝕡𝕣𝕚𝕟𝕔𝕖𝕤𝕤",
    "蒙†ђэ∂๏иล†๏12M",
    "꧁༒☬ᤂৡ☬༒",
    "Ｋｏｎｔｏｌ",
    "᯽.ﾟ🐻🧋 𓏲𝙯ഠy𓂅 🧸 ✦.  ࣪.",
    "꧁𝓽𝓱𝓮𝓆𝓾𝓮𝓮𝓃꧂",
    "GHOST_",
    "𖡼𖡺ρriทcєsα𖡺𖡼",
    "ᝯꢷ𐐫ѡѡเꦌ",
    "☯Ƥ᭄O v e r s h o t",
    "⩩ . ִ ֗ 💭 ⦂ 𝓝𐓟ꮻꭑꪱ ɤ 𝗽ә𝘁ɑ",
    "꧁✿️๖ۣۜƊeͥαlͣoͫvαɢɪʀʟ꧂",
    "ASTG〆CAPTｼ〆",
    "M͜͡4 | BOND",
    "༎།Ꭻєຮυຮ᛭₂₉☂",
    "Madagascar",
    "Unicode Circled Numbers ① ② ③",
    "蒙DTE JANO蒙",
    "`💍´ 𓂅 𝙴𝚜𝚝𝚞𝚙𝚒𝚍!! 𔘓",
    "dᥙkι",
    "ᵐᵇᵃᵏJum",
    "Qᴜᴇᴇɴ ꜱɪᴅʀᴀ亗",
    "Камыр",
    "꧁s☢ldier gaming꧂",
    "|~🐻~ °• Fislly •° ~🍫~|",
    "ζ͜͡๛»A͢ӄr͠E͏p͏🍹』",
    "Mowwie",
    "ㅱ",
    "βυмβLΣ βΣΣ",
    "ネテロ",
    "⚔ℭⲅ𝖎𝐬᥏𝔥𝔬ꭾ𝖊𝖗᛭₂₉☂",
    "A G ☯ A M I T",
    "ꔛ៳₊˚꒰☕୧ᨓ•𝒀𝓾𝓇𝓲  ˖⸙̭❛﹕",
    "ꭑꭒઽꪱƖ𐓟ꭑ𐓟ჩ ꭉꪱ𐓟ꬼꪱ",
    "Clowie Aralia Nathalie Meganta",
    "AWARA 69 亗",
    "ᴜNICODE",
    "쇼H A M A쇼",
    "★NᎥme★",
    "DELİSİYİM",
    "꧁☬รµмקℓэ¢ђэ†๏☬꧂",
    "ELİFİM",
    "Cuplis•Ganz?",
    "𝓚𝓐𝓛𝓘 𝓛𝓘𝓝𝓤𝓧",
    "SON S ⁹⁹",
    "“🔥” U+1F525",
    "블퍼",
    "Meisya bach",
    "Qzmbysics",
    "Jyushi Kim",
    "•𝐋e 𓍢‌۟ᏰS",
    "𝕌ภicØ∂e🌸Pretty Lovarie",
    "💒~• Yera •~💒",
    "ꙮ",
]

const otherNames = [
    "Beynaa",
    "Tenang Aja",
    "Tuti",
    "Aagam31",
    "Neeraj Neeraj Bhai",
    "Vellyn",
    "TRIDENT",
    "Yeriin",
    "Putri"
];


const usernames = [
    ...coolNames,
    ...animeNames,
    ...elfFemale,
    ...elfMale,
    ...fantasyNames,
    ...medievalNames,
    ...futuristicNames,
    ...hackerNames,
    ...unicodeNames,
    ...otherNames,
]

export function getRandomUsername() {
    return usernames[Math.floor(Math.random() * usernames.length)];
}
